module.exports = __webpack_public_path__ + "img/yangBanner.45a5e319.jpg";